/**
 * Token Service for managing JWT tokens in localStorage
 */

const TOKEN_KEY = 'jwt_token';

export const tokenService = {
    /**
     * Store JWT token in localStorage
     */
    setToken: (token: string): void => {
        try {
            console.log('?? TokenService: Storing token');
            localStorage.setItem(TOKEN_KEY, token);
            console.log('? TokenService: Token stored successfully');
        } catch (error) {
            console.error('? TokenService: Failed to store token:', error);
        }
    },

    /**
     * Retrieve JWT token from localStorage
     */
    getToken: (): string | null => {
        try {
            const token = localStorage.getItem(TOKEN_KEY);
            console.log('?? TokenService: Token retrieved:', token ? 'EXISTS' : 'NULL');
            return token;
        } catch (error) {
            console.error('? TokenService: Failed to retrieve token:', error);
            return null;
        }
    },

    /**
     * Remove JWT token from localStorage
     */
    removeToken: (): void => {
        try {
            console.log('??? TokenService: Removing token');
            localStorage.removeItem(TOKEN_KEY);
            console.log('? TokenService: Token removed successfully');
        } catch (error) {
            console.error('? TokenService: Failed to remove token:', error);
        }
    },

    /**
     * Check if token exists
     */
    hasToken: (): boolean => {
        const hasToken = !!tokenService.getToken();
        console.log('?? TokenService: Has token:', hasToken);
        return hasToken;
    }
};